export function getBaseURL() {
    // set back-end endpoints
    let baseurl = 'http://localhost:3000'
    if(process.env.NODE_ENV === 'production') {
        //console.log('production')
        baseurl = 'https://upays-server-031285db46a4.herokuapp.com'
    }else {
        //console.log('development')
    }
    return baseurl
}